import star from "~/images/landing/star.svg"

export const StarDecoration = ({
  width = 26,
  height = 26,
}: {
  width?: number
  height?: number
}) => {
  return <img src={star} alt="Star" width={width} height={height} className="animate-pulse" />
}
